export default {
  name: 'us',
  decorateRequest(request) {
    const requestOptions = request.requestOptions || {};
    requestOptions.headers = request.requestOptions.headers || {};
    requestOptions.headers.Authorization = request.token;
    return requestOptions;
  },
};
